import React, { useEffect, useState, useRef } from "react";
import {
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Grid,
  Typography,
  Checkbox,
  Table,
  Modal,
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Container,
  AppBar,
  Toolbar,
  CircularProgress,
  InputAdornment,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { keyframes } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import SearchIcon from '@mui/icons-material/Search';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SchoolIcon from "@mui/icons-material/School";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import FilterListIcon from "@mui/icons-material/FilterList";
import SendIcon from "@mui/icons-material/Send";
import StreamIcon from "@mui/icons-material/Waves";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Animation for sliding in the paper
const slideIn = keyframes`
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const StyledAppBar = styled(AppBar)({
  backgroundColor: "#0B1F3D",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
});

const StyledPaper = styled(Paper)({
  padding: "24px",
  marginTop: "16px",
  borderRadius: "8px",
  animation: `${slideIn} 0.5s ease-out`,
});

const AddAttendance = () => {
  let navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [classList, setClassList] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState("");
  const [sectionList, setSectionList] = useState([]);
  const [selectedSectionId, setSelectedSectionId] = useState("");
  const [studentList, setStudentList] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [isStudentDataFetched, setIsStudentDataFetched] = useState(false);
  const [date, setDate] = useState("");
  const [attendanceMap, setAttendanceMap] = useState({});
  const [streamsList, setStreamsList] = useState([]);
  const [selectedStream, setSelectedStream] = useState("");
  const [showStreamDropdown, setShowStreamDropdown] = useState(false);
  const [shouldFetchStudents, setShouldFetchStudents] = useState(false);
  const [noStudentsMessage, setNoStudentsMessage] = useState("No students found");
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = [10, 25, 50];
  const [selectAttendanceStatus, setSelectAttendanceStatus] = useState("present");

  // Info dialog state
  const [infoOpen, setInfoOpen] = useState(false);

  // Pahle jaise date format function
  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    // Pahle jaise automatically today's date set karna
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const todayDate = `${year}-${month}-${day}`;
    setDate(todayDate);

    fetchClasses(); 
    fetchStreams();
  }, []);

  const handleCheckboxChange = (studentId) => {
    setSelectedStudents((prevSelectedStudents) => ({
      ...prevSelectedStudents,
      [studentId]: !prevSelectedStudents[studentId],
    }));
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedStudents({});
    } else {
      const newSelectedStudents = {};
      studentList.forEach(student => {
        newSelectedStudents[student.studentId] = true;
      });
      setSelectedStudents(newSelectedStudents);
    }
    setSelectAll(!selectAll);
  };

  const fetchStreams = async () => {
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Stream/GetAllStreams`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ streamID: 0 }),
      });

      if (!response.ok) {
        throw new Error(`Error fetching streams: ${response.status}`);
      }

      const data = await response.json();
      if (!data || !Array.isArray(data)) {
        setStreamsList([]);
        return;
      }

      setStreamsList(data);
    } catch (error) {
      console.error("Error fetching streams:", error);
      setStreamsList([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchClasses = async () => {
  setLoading(true);
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      throw new Error(`Error fetching classes: ${response.status}`);
    }
    const data = await response.json();
    if (data.data === null && data.msg === "Record Not Found") {
      return;
    }
    setClassList(data);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

 const fetchSections = async (classId) => {
  setLoading(true);
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/ClassPromotion/ddlSection_clsId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ teacherId: 0, classId }),
    });

    if (!response.ok) {
      throw new Error(`Error fetching sections: ${response.status}`);
    }
    const data = await response.json();
    if (data.data === null && data.msg === "Record Not Found") {
      return;
    }
    setSectionList(data);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  const fetchStudents = async (classId, sectionId, streamName) => {
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Attendance/GetStudentById`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          classId,
          sectionId,
          stream: streamName === "all" ? "0" : streamName || "0",
        }),
      });

      if (!response.ok) {
        throw new Error(`Error fetching students: ${response.status}`);
      }

      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setStudentList([]);
        setFilteredStudents([]);
        setIsStudentDataFetched(false);
        setNoStudentsMessage(
          selectedStream
            ? `No students found for ${selectedStream} stream`
            : "No students found"
        );
        return;
      }

      if (Array.isArray(data)) {
        setStudentList(data);
        setFilteredStudents(data);
        setIsStudentDataFetched(true);
        setNoStudentsMessage("No students found");
      } else {
        console.error("API response is not an array:", data);
        setStudentList([]);
        setFilteredStudents([]);
        setIsStudentDataFetched(false);
        setNoStudentsMessage(
          selectedStream
            ? `No students found for ${selectedStream} stream`
            : "No students found"
        );
      }
    } catch (error) {
      console.error("Error fetching students:", error);
      setStudentList([]);
      setFilteredStudents([]);
      setIsStudentDataFetched(false);
      setNoStudentsMessage(
        selectedStream
          ? `No students found for ${selectedStream} stream`
          : "No students found"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  if (studentList.length > 0) {
    const newAttendanceMap = {};
    studentList.forEach((student) => {
      newAttendanceMap[student.studentId] = selectAttendanceStatus;
    });
    setAttendanceMap(newAttendanceMap);
  }
}, [studentList]);

useEffect(() => {
  if (selectedClassId) {
    fetchSections(selectedClassId);
  }
}, [selectedClassId]);

  useEffect(() => {
    if (shouldFetchStudents && selectedClassId && selectedSectionId) {
      if (showStreamDropdown && !selectedStream) {
        setStudentList([]);
        setFilteredStudents([]);
        setIsStudentDataFetched(false);
        setNoStudentsMessage("Please select a stream");
        return;
      }
      fetchStudents(selectedClassId, selectedSectionId, selectedStream);
    }
  }, [
    selectedClassId,
    selectedSectionId,
    selectedStream,
    shouldFetchStudents,
    showStreamDropdown,
  ]);

  useEffect(() => {
    if (!selectedClassId) {
      setShowStreamDropdown(false);
      setShouldFetchStudents(false);
      return;
    }

    const selectedClass = classList.find(
      (classItem) => classItem.classId === selectedClassId
    );

    if (!selectedClass) {
      setShowStreamDropdown(false);
      setShouldFetchStudents(false);
      return;
    }

    const classNumberMatch = selectedClass.className.match(/\d+/);
    if (!classNumberMatch) {
      setShowStreamDropdown(false);
      setShouldFetchStudents(false);
      return;
    }

    const classNumber = parseInt(classNumberMatch[0], 10);
    const shouldShowStream = classNumber >= 10;
    setShowStreamDropdown(shouldShowStream);

    setSelectedStream("");

    if (!shouldShowStream) {
      setShouldFetchStudents(true);
    } else {
      setShouldFetchStudents(false);
    }
  }, [selectedClassId, classList]);

  const handleAttendanceChange = (e, studentId) => {
    const newAttendanceMap = { ...attendanceMap };
    if (newAttendanceMap[studentId] === e.target.value) {
      delete newAttendanceMap[studentId];
    } else {
      newAttendanceMap[studentId] = e.target.value;
    }
    setAttendanceMap(newAttendanceMap);
  };

  const handleSelectAllPresent = (status) => {
    const newAttendanceMap = {};
    studentList.forEach((student) => {
      newAttendanceMap[student.studentId] = status;
    });
    setAttendanceMap(newAttendanceMap);
  };

  const handleClearSelection = (studentId) => {
    const newAttendanceMap = { ...attendanceMap };
    delete newAttendanceMap[studentId];
    setAttendanceMap(newAttendanceMap);
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    if (!query.trim()) {
      setFilteredStudents(studentList);
      return;
    }

    const filtered = studentList.filter((student) => {
      const studentName = student.studentName?.toLowerCase() || "";
      const rollNo = student.rollNo?.toLowerCase() || "";
      const mobileNo = student.mobileNo?.toLowerCase() || "";
      const stream = student.stream?.toLowerCase() || "";

      return (
        studentName.includes(query) ||
        rollNo.includes(query) ||
        mobileNo.includes(query) ||
        stream.includes(query)
      );
    });

    setFilteredStudents(filtered);
    setPage(1);
  };

  const resetForm = () => {
    setSelectedClassId("");
    setSelectedSectionId("");
    setSelectedStream("");
    setStudentList([]);
    setFilteredStudents([]);
    setAttendanceMap({});
    setSelectAll(false);
    setShouldFetchStudents(false);
    setIsStudentDataFetched(false);
    setNoStudentsMessage("No students found");
    setSearchQuery("");
    // Reset to current date
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const todayDate = `${year}-${month}-${day}`;
    setDate(todayDate);
  };

  const handleSubmit = async () => {
  if (!date) {
    setSnackbarMessage('Please fill the date field.');
    setOpenSnackbar(true);
    setSnackbarSeverity("warning");
    return;
  }

  const checkedStudents = studentList.filter(
    (student) => selectedStudents[student.studentId]
  );

  if (checkedStudents.length === 0) {
    setSnackbarMessage('Please select at least one student.');
    setOpenSnackbar(true);
    setSnackbarSeverity("warning");
    return;
  }

  setLoading(true);
  try {
    const url = process.env.REACT_APP_BASE_URL;
    const apiUrl = `${url}/Attendance`;
    const token = sessionStorage.getItem("token");

    const formattedDate = formatDate(date);

    const requestBody = {
      classId: selectedClassId,
      sectionId: selectedSectionId,
      attendenceDate: formattedDate,
      attendence: checkedStudents.map((student) => ({
        studentId: student.studentId,
        isAbsent: attendanceMap[student.studentId] === "absent",
        isPresent: attendanceMap[student.studentId] === "present",
      })),
    };

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(requestBody),
    });

    if (response.ok) {
      setShowSuccessModal(true);
      resetForm();
    } else {
      setSnackbarMessage('Failed to post attendance data');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  } catch (error) {
    setSnackbarMessage("API request error: " + error.message);
    setOpenSnackbar(true);
    setSnackbarSeverity("error");
  } finally {
    setLoading(false);
  }
}; 

  const handleStreamChange = (e) => {
    setSelectedStream(e.target.value);
    if (showStreamDropdown) {
      setShouldFetchStudents(true);
    }
  };

  const handleSelectAttendanceStatus = (status) => {
    setSelectAttendanceStatus(status);
    handleSelectAllPresent(status);
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const paginatedData = filteredStudents.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container maxWidth="lg">
      <StyledAppBar position="static">
        <Toolbar sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h4" style={{ fontWeight: 'bold' }}>
            Student Attendance Form
          </Typography>

          {/* ── Info Button ── */}
          <Tooltip title="About this form" arrow>
            <IconButton
              onClick={() => setInfoOpen(true)}
              size="small"
              sx={{
                color: "rgba(255,255,255,0.75)",
                border: "1.5px solid rgba(255,255,255,0.35)",
                borderRadius: "50%",
                width: 30,
                height: 30,
                ml: 0.5,
                transition: "all 0.2s ease",
                "&:hover": {
                  color: "#ffffff",
                  backgroundColor: "rgba(100,181,246,0.2)",
                  borderColor: "#64B5F6",
                  transform: "scale(1.1)",
                  boxShadow: "0 0 8px rgba(100,181,246,0.4)",
                },
              }}
            >
              <InfoOutlinedIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </StyledAppBar>

      <StyledPaper elevation={3}>

        {/* Filters Section - All in one row with proper sizing */}
        <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap", alignItems: "center" }}>
         

          <FormControl sx={{ minWidth: 150, flexGrow: 1 }}>
            <InputLabel>Class</InputLabel>
            <Select
              value={selectedClassId}
              onChange={(e) => {
                setSelectedClassId(e.target.value);
                setSelectedSectionId("");
                setSelectedStream("");
                setStudentList([]);
                setFilteredStudents([]);
                setNoStudentsMessage("No students found");
              }}
              label="Class"
            >
              {classList.map((classItem) => (
                <MenuItem key={classItem.classId} value={classItem.classId}>
                  {classItem.className}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 150, flexGrow: 1 }}>
            <InputLabel>Section</InputLabel>
            <Select
              value={selectedSectionId}
              onChange={(e) => {
                setSelectedSectionId(e.target.value);
                if (!showStreamDropdown) {
                  setShouldFetchStudents(true);
                }
                setNoStudentsMessage("No students found");
              }}
              label="Section"
            >
              {Array.isArray(sectionList) && sectionList.length > 0 ? (
                sectionList.map((sectionItem) => (
                  <MenuItem
                    key={sectionItem.sectionId}
                    value={sectionItem.sectionId}
                  >
                    {sectionItem.sectionName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">No sections found</MenuItem>
              )}
            </Select>
          </FormControl>

          {showStreamDropdown && (
            <FormControl sx={{ minWidth: 150, flexGrow: 1 }}>
              <InputLabel>Stream</InputLabel>
              <Select
                value={selectedStream}
                onChange={handleStreamChange}
                label="Stream"
              >
                <MenuItem value="">Select Stream</MenuItem>
                <MenuItem value="all">All Streams</MenuItem>
                {Array.isArray(streamsList) && streamsList.length > 0 ? (
                  streamsList.map((stream) => (
                    <MenuItem key={stream.streamID} value={stream.streamName}>
                      {stream.streamName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No streams available</MenuItem>
                )}
              </Select>
            </FormControl>
          )}

          <TextField
            id="date"
            label="Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={date}
            onChange={handleDateChange}
            sx={{ minWidth: 180, flexGrow: 1 }}
          />

          <TextField
            label="Search Students"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearchChange}
            sx={{ minWidth: 250, flexGrow: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <CircularProgress color="primary" />
          </Box>
        )}

        {/* Bulk Action Section - Exactly like second code */}
        {isStudentDataFetched && (
          <Box
            sx={{
              mb: 2,
              p: 2,
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <Typography variant="h6" sx={{ color: "#1976d2", fontWeight: "bold" }}>
              Mark Attendance for Selected ({Object.values(selectedStudents).filter(Boolean).length} selected)
            </Typography>

            <RadioGroup
              row
              value={selectAttendanceStatus}
              onChange={(e) => handleSelectAttendanceStatus(e.target.value)}
            >
              <FormControlLabel
                value="present"
                control={<Radio />}
                label={<Typography fontWeight="bold" color="green">Present</Typography>}
              />
              <FormControlLabel
                value="absent"
                control={<Radio />}
                label={<Typography fontWeight="bold" color="red">Absent</Typography>}
              />
            </RadioGroup>
          </Box>
        )}

        {/* Table Section */}
        {isStudentDataFetched && (
          <>
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: "500px",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                mb: 2,
              }}
            >
              <Table
                stickyHeader
                sx={{
                  minWidth: 650,
                  '& .MuiTableCell-root': {
                    borderRight: '1px solid #e0e0e0',
                    fontSize: '0.95rem',
                  },
                  '& .MuiTableHead-root .MuiTableCell-root': {
                    fontWeight: 'bold',
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', width: "80px" }}>
                      S.No.
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', width: "100px" }}>
                      <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAll}
                        indeterminate={
                          Object.values(selectedStudents).filter(Boolean).length > 0 &&
                          Object.values(selectedStudents).filter(Boolean).length < filteredStudents.length
                        }
                      />
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      Student Name
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      Roll No
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      Mobile No
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      Stream
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', minWidth: "250px" }}>
                      Attendance Status
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.length > 0 ? (
                    paginatedData.map((student, index) => (
                      <TableRow
                        key={student.studentId}
                        sx={{
                          '&:hover': { backgroundColor: '#f9f9f9' },
                          backgroundColor: selectedStudents[student.studentId] ? '#e3f2fd' : 'inherit',
                        }}
                      >
                        <TableCell>
                          {(page - 1) * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell>
                          <Checkbox
                            checked={!!selectedStudents[student.studentId]}
                            onChange={() => handleCheckboxChange(student.studentId)}
                          />
                        </TableCell>
                        <TableCell sx={{ fontWeight: 500 }}>
                          {student.studentName}
                        </TableCell>
                        <TableCell>
                          {student.rollNo}
                        </TableCell>
                        <TableCell>
                          {student.mobileNo}
                        </TableCell>
                        <TableCell>
                          {student.stream || "N/A"}
                        </TableCell>
                        <TableCell>
                          <FormControl component="fieldset">
                            <RadioGroup
                              row
                              value={attendanceMap[student.studentId] || ""}
                              onChange={(e) => handleAttendanceChange(e, student.studentId)}
                            >
                              <FormControlLabel
                                value="present"
                                control={<Radio size="small" />}
                                label={<Typography fontSize="0.9rem" color="green">Present</Typography>}
                              />
                              <FormControlLabel
                                value="absent"
                                control={<Radio size="small" />}
                                label={<Typography fontSize="0.9rem" color="red">Absent</Typography>}
                              />
                            </RadioGroup>
                          </FormControl>
                          <Button
                            onClick={() => handleClearSelection(student.studentId)}
                            size="small"
                            color="secondary"
                            sx={{ mt: 0.5 }}
                          >
                            Clear
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        <Typography variant="body1" sx={{ py: 3 }}>
                          {noStudentsMessage}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination Controls */}
            {filteredStudents.length > 0 && (
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                <TextField
                  select
                  label="Rows per page"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  sx={{ width: 150 }}
                  SelectProps={{ native: true }}
                >
                  {rowsPerPageOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </TextField>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Typography variant="body2">
                    Page {page} of {Math.ceil(filteredStudents.length / rowsPerPage)}
                    &nbsp;({filteredStudents.length} total students)
                  </Typography>
                  <Button
                    variant="outlined"
                    onClick={() => handleChangePage(null, page - 1)}
                    disabled={page === 1}
                    sx={{ minWidth: "80px" }}
                  >
                    Prev
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => handleChangePage(null, page + 1)}
                    disabled={page >= Math.ceil(filteredStudents.length / rowsPerPage)}
                    sx={{ minWidth: "80px" }}
                  >
                    Next
                  </Button>
                </Box>
              </Box>
            )}
          </>
        )}

        {/* Action Buttons */}
        <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{ minWidth: "120px" }}
          >
            Back to Home
          </Button>

          <Tooltip title="Select a student to mark attendance" arrow><span>
        <Button
  variant="contained"
  onClick={handleSubmit}
  disabled={loading || Object.values(selectedStudents).filter(Boolean).length === 0}
  sx={{ minWidth: "150px" }}
>
  {loading ? "Submitting..." : "Mark Attendance"}
</Button> </span> </Tooltip>
        </Box>
      </StyledPaper>

      {/* Success Modal */}
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Attendance Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              The Attendance data has been posted successfully.
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* ── Info Dialog ── */}
      <Dialog
        open={infoOpen}
        onClose={() => setInfoOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "16px",
            boxShadow: "0 12px 40px rgba(11,31,61,0.2)",
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #0B1F3D 0%, #1565C0 100%)",
            color: "#ffffff",
            fontWeight: 700,
            fontSize: "1.2rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <InfoOutlinedIcon sx={{ fontSize: 22 }} />
            Student Attendance Form — Guide
          </Box>
          
        </DialogTitle>

        <DialogContent sx={{ px: 3, py: 2.5 }}>

          {/* Purpose */}
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.7 }}>
            Use this form to record daily attendance for students. Select a teacher, class,
            section, and date to load the student list, then mark each student as Present or
            Absent before submitting.
          </Typography>

          <Divider sx={{ mb: 2 }} />

          {/* Step by step */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            How to Use — Step by Step
          </Typography>

          <List dense disablePadding>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <PersonOutlineIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Step 1 — Select Teacher</Typography>}
                secondary="Choose the teacher. This loads the classes assigned to that teacher."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <SchoolIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Step 2 — Select Class</Typography>}
                secondary="Pick a class from the list. This loads the sections for that class. For Class 10 and above, a Stream dropdown also appears."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <MeetingRoomOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Step 3 — Select Section</Typography>}
                secondary="Choose a section. This triggers student loading (unless a stream selection is also required)."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <StreamIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Step 4 — Select Stream (Class 10+)</Typography>}
                secondary="For Class 10 and above, select a stream (Science, Commerce, Arts, etc.) or 'All Streams' to load students."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <CalendarTodayIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Step 5 — Set Date</Typography>}
                secondary="The date defaults to today and can be changed. Date is required before submitting."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <CheckBoxIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Step 6 — Mark Attendance</Typography>}
                secondary="Use the bulk radio buttons (Present / Absent) above the table to set all students at once, or set each student individually using the row-level radio buttons. The header checkbox selects/deselects all rows."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <SendIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Step 7 — Submit</Typography>}
                secondary="Click 'Mark Attendance' to save the records. A success modal confirms submission. Clicking OK navigates back and resets the form."
              />
            </ListItem>

          </List>

          <Divider sx={{ my: 2 }} />

          {/* Status legend */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Attendance Status Options
          </Typography>
          <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, px: 1.5, py: 0.6, backgroundColor: "#f0fff4", borderRadius: "6px", border: "1px solid green" }}>
              <CheckCircleOutlineIcon sx={{ fontSize: 16, color: "green" }} />
              <Typography variant="body2" fontWeight={600} color="green">Present</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, px: 1.5, py: 0.6, backgroundColor: "#fff5f5", borderRadius: "6px", border: "1px solid red" }}>
              <CancelOutlinedIcon sx={{ fontSize: 16, color: "red" }} />
              <Typography variant="body2" fontWeight={600} color="red">Absent</Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Important notes */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Important Notes
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            {[
              "Teacher → Class → Section is a cascading chain; each selection loads the next dropdown.",
              "For Class 10 and above, a Stream dropdown appears and must be selected before students load.",
              "The Date field is required — submitting without a date shows a warning.",
              "Students with no attendance marked are submitted with isPresent: false and isAbsent: false.",
              "Use the Clear button on any row to remove that student's attendance selection.",
              "The Search field filters by student name, roll number, mobile number, or stream.",
              "After a successful submission the form resets automatically to today's date.",
            ].map((note, i) => (
              <Typography key={i} component="li" variant="body2" color="text.secondary" sx={{ mb: 0.5, lineHeight: 1.6 }}>
                {note}
              </Typography>
            ))}
          </Box>

        </DialogContent>

        <DialogActions sx={{ backgroundColor: "#f5f5f5", px: 3, py: 2 }}>
          <Button
            onClick={() => setInfoOpen(false)}
            variant="contained"
            sx={{
              backgroundColor: "#0B1F3D",
              color: "#fff",
              borderRadius: "8px",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#1565C0" },
            }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>
      {/* ── End Info Dialog ── */}

    </Container>
  );
};

export default AddAttendance;